// Third party libraries
import Vue from 'vue';
import store from '@/store/index.js';
import VueNumerals from 'vue-numerals';

// Third party plugins
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueToasted from 'vue-toasted';

// CSS stylesheets
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import './CSS/jll.dx.scheme.css';
import './CSS/post.css';
import './CSS/bootstrapOverwrites.css';
import './CSS/pix-bootstrap.css';
import './CSS/jll-palette.css';
import './CSS/global-styles.css';
import './CSS/jll-variables.css';
import './CSS/jll-font.css';
import './CSS/pixToasted.css';
import '../node_modules/@mdi/font/css/materialdesignicons.min.css';

// Components CSS
import './CSS/components/pix-range-input.css';
import './CSS/components/pix-generic-table.css';
import './CSS/components/pix-checkbox.css';
import router from '@/services/routing/router.js';
import i18nUtils from '@/services/i18n/i18n.utils.js';
import localstorageManager from 'jll-localstorage-manager';
import buildVariables from '../buildVariables.js';
import pixCustomToasted from '@/shared/pixCustomToasted.js';
import appVue from './components/App.vue';
import { initGoogleMapsKey, initDeployEnvironment, initPendo, initChromaticUrl, initErrorInterceptors, initAppInsights } from './services/boot.utils.js';

// Global components registration
import globalComponents from '@/shared/globalComponents.js';

// Vue plugins and initialization dependencies

globalComponents.registerGlobalComponents();

// Vue plugins
Vue.use(VueLoading, { color: 'red', width: 48, height: 48 });
Vue.use(VueNumerals); // default locale is 'en'
Vue.use(VueToasted, { iconPack: 'mdi', duration: 5000, keepOnHover: true });
pixCustomToasted.registerCustomToasts(Vue.toasted.register);

const i18n = i18nUtils.init(Vue);

// Vue app creation
new Vue({
  el: '#app-root',
  i18n,
  store,
  router,
  render: (h) => h(appVue),
  created() {
    initErrorInterceptors(this.$store.getters.langCode, this.$store);
    localstorageManager.initLocalStorage(buildVariables.buildNumber);
    this.$store.watch(
      (state, getters) => {
        return getters['authModule/isAuthenticated'];
      },
      (isAuthenticated) => {
        if (isAuthenticated) {
          localstorageManager.initLocalStorage(buildVariables.buildNumber, this.$store.getters['authModule/instance'], this.$store.getters.langCode);
          initGoogleMapsKey(this.$store);
          initDeployEnvironment(this.$store, this.$store.getters['authModule/UserName'], this.$store.getters['authModule/instance']);
          initPendo(this.$store.getters['authModule/UserName'], this.$store.getters['authModule/instance']);
          initChromaticUrl(this.$store);
          initAppInsights(router, Vue);
        }
      },
      { immediate: true }
    );
  },
});
